import React from 'react';
import { handleWechatLinkClick } from '../utils/wechatLink';
import { getExchangeInviteCode } from '../data/rebateData';

function ExchangeRegisterBanner({
  exchange,
  title,
  description,
  cta = '前往注册',
  className = '',
}) {
  if (!exchange || exchange.registerUrl === '#') return null;

  const classes = ['rebate-register-banner', className].filter(Boolean).join(' ');
  const inviteCode = getExchangeInviteCode(exchange);

  return (
    <a
      className={classes}
      href={exchange.registerUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${exchange.name} 注册入口`}
      onClick={handleWechatLinkClick}
      style={{ '--exchange-accent': exchange.accent }}
    >
      <div className="rebate-register-banner-brand">
        <img src={exchange.logo} alt={`${exchange.name} logo`} />
      </div>
      <div className="rebate-register-banner-text">
        <strong>{title || exchange.directCta}</strong>
        <span>{description || `${exchange.shortName} 专属注册链接 · 邀请码 ${inviteCode}`}</span>
      </div>
      <span className="rebate-register-banner-cta">{cta}</span>
    </a>
  );
}

export default ExchangeRegisterBanner;
